import { useTranslations } from 'next-intl'

import { Props } from './index.pc'
import { Heading } from '../../common'

export const MobileIntroduction = ({ description }: Props) => {
  const t = useTranslations('room_detail')

  return (
    <section className="space-y-4 px-4 py-10">
      <Heading size="small">{t('unit_detail.title')}</Heading>
      <p className="typo-body2 font-normal whitespace-break-spaces text-gray-900">
        {description}
      </p>
    </section>
  )
}
